import { makeStyles } from "@material-ui/core/styles";

const textFieldUseStyles = makeStyles(() => ({
  input: {
    position: "relative",
    width: "100%",
    backgroundColor: "#FFFFFF",
    border: "0.5px solid #969696 ",
    borderRadius: "2px",
    opacity: 1,
    "&:hover": {
      backgroundColor: "#F8F8F8"
    },
    "&:focus-within": {
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 0px 8px #12837033",
      border: "0.5px solid #6DD8CD"
    },
    "& .Mui-error": {
      border: "0.5px solid #E4001C",
      height: 30
    }
  },
  textfield: {
    fontSize: 12,
    color: "#000000",
    "&.Mui-disabled": {
      backgroundColor: "#e1e1e1",
      opacity: 0.5,
      color: "#000000"
    }
  },
  placeHolder: {
    color: "#969696"
  },
  label: {
    fontSize: 16,
    color: "#000000"
  },
  labelDisabled: {
    color: "#969696"
  }
}));

export { textFieldUseStyles };
